// extracted by mini-css-extract-plugin
module.exports = {"primary-nav-links":"style_primary-nav-links__P3r1k","primary-nav-link":"style_primary-nav-link__4yFZi","active":"style_active__tA39T"};